import React from "react";

export default function AppLoading() {
  const [slow, setSlow] = React.useState(false);
  React.useEffect(() => {
    const t = window.setTimeout(() => setSlow(true), 12000);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#f9fafb",
        zIndex: 99999,
        fontFamily: "'Rubik', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: 16,
      }}
    >
      <style>{`
        @keyframes v-al-pulse { 0%,100%{opacity:1} 50%{opacity:0.7} }
        @keyframes v-al-dot-1 { 0%,20%{opacity:0} 30%,80%{opacity:1} 100%{opacity:0} }
        @keyframes v-al-dot-2 { 0%,40%{opacity:0} 50%,90%{opacity:1} 100%{opacity:0} }
        @keyframes v-al-dot-3 { 0%,60%{opacity:0} 70%,100%{opacity:1} }
        .v-al-wordmark { font-size: 40px; }
        @media (max-width: 640px) { .v-al-wordmark { font-size: 30px; } }
      `}</style>

      <div
        className="v-al-wordmark"
        style={{
          fontWeight: 800,
          color: "#0f172a",
          letterSpacing: "-1px",
          lineHeight: 1,
          animation: "v-al-pulse 2.4s ease-in-out infinite",
        }}
      >
        velaro<span style={{ color: "#2FBF71" }}>.</span>
      </div>

      {!slow ? (
        <span
          style={{
            color: "#6b7280",
            fontSize: 13,
            display: "inline-flex",
            alignItems: "baseline",
          }}
        >
          Loading
          <span style={{ display: "inline-flex", width: "1.2em", marginLeft: 1 }}>
            <span style={{ animation: "v-al-dot-1 1.6s infinite", opacity: 0 }}>.</span>
            <span style={{ animation: "v-al-dot-2 1.6s infinite", opacity: 0 }}>.</span>
            <span style={{ animation: "v-al-dot-3 1.6s infinite", opacity: 0 }}>.</span>
          </span>
        </span>
      ) : (
        <div style={{ textAlign: "center", maxWidth: 320 }}>
          <div style={{ color: "#374151", fontSize: 14, marginBottom: 4 }}>Still loading…</div>
          <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 14 }}>
            {navigator.onLine
              ? "This is taking longer than usual."
              : "You appear to be offline."}
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: "#4C75AB",
              color: "white",
              border: "none",
              borderRadius: 6,
              padding: "8px 20px",
              fontSize: 13,
              fontWeight: 500,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Retry
          </button>
        </div>
      )}
    </div>
  );
}
